import axios from "axios";

const sendMail = (user_email, name, date, day, time, title, id) => {
    const config = {
        admin_email: "info@turnhalle-hh.de",
        key: "turnhalle_wins_789f455s87f954a4",
        endpoint: "https://turnhalle-hh.de/endpoint/mailer.php"
    };


    axios.get(config.endpoint, {
        

        params: {
            admin_email: config.admin_email,
            key: config.key,
            user_email,
            name,
            date,
            day,
            time,
            title,
            deletion_slug: window.location.href +id+'/'+ day + '/'+ date + '/' + time
        
      }
    })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
}

export default sendMail;